import { Component, ElementRef, viewChildren, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-stepper',
  imports: [],
  templateUrl: './stepper.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './stepper.component.scss'
})
export class StepperComponent {
  
  steps = viewChildren<ElementRef<HTMLDivElement>>('step');

}
